import { FC } from 'react'

import { useHistory, useParams } from 'react-router-dom'
import { SwitchTabs } from '@pepper/ui'

import { useProjectTopics } from 'utils/hooks/useProjectTopics'
import { useProjectKeywords } from 'utils/hooks/useProjectKeywords'
import { useSelectedCompanyId } from 'utils/functions/misc'
import { LabTab } from '../../types'

import s from './LabRouteSwitch.module.css'

export const LabRouteSwitch: FC = () => {
  const history = useHistory()
  const companyId = useSelectedCompanyId()
  const { projectId, tab } = useParams<{
    projectId: string
    tab: LabTab
  }>()

  const routePrefix = `/project/${projectId}`

  const { data: topics } = useProjectTopics({
    projectId,
    companyId,
    page: 1,
    limit: 1,
    enabled: tab === 'keywords' || tab === 'topics',
  })

  const { data: keywords } = useProjectKeywords({
    projectId,
    companyId,
    page: 1,
    limit: 1,
  })

  return (
    <div className={s.toggle} data-id="topics-keywords-switcher">
      <SwitchTabs
        activeTab={tab}
        onTabChange={(_tab: string) => {
          history.push({
            pathname: `${routePrefix}/${_tab}`,
            search: undefined,
          })
        }}
        tabList={[
          {
            title: `Topics (${topics?.total_records ?? 0})`,
            value: 'topics',
          },
          {
            title: `Keywords (${keywords?.total_records ?? 0})`,
            value: 'keywords',
          },
        ]}
      />
    </div>
  )
}
